import React from "react";
import FlexibleDateBestPriceInner from "./FlexibleDateBestPriceInner.js";
import { useGetFlexDatesData } from "./useGetFlexDatesData.js";
import Frame from "../Frame/index.js";
const FlexibleDateBestPriceDesktop = () => {
    const data = useGetFlexDatesData();
    if (!data) {
        return null;
    }
    const { dates, currentBestPrice, cheaperCount, isOneWay } = data;
    return (React.createElement(Frame, { mb: 4 },
        React.createElement(FlexibleDateBestPriceInner, { carouselSize: "medium", dates: dates, currentBestPrice: currentBestPrice, cheaperCount: cheaperCount, isOneWay: isOneWay })));
};
export default FlexibleDateBestPriceDesktop;
